import { createContext, useContext } from "react";
import { action, makeAutoObservable, makeObservable, observable, runInAction } from "mobx";
import { postMethodData, getMethodData, putMethod, delMethod, patchMethodData } from "../../ApiMethods/api";
import { toast } from "react-toastify";
const SEO_URL = process.env.REACT_APP_SEO_URL;





export class QueryStore {

    Token = null;
    Query = [];
    type = "";
    QueryLoader = false;
    Querytype = [];
    filterSearch = "";
    PaginationPage = "1";
    TotalPages = "";
    QueryDimiensions = ""
    crop = {};
    errLoadQuery = "";
    LoadQuery = false;
    delateLoader = false;
    nolist = false;
    Querypopup = false;
    deletepopup = false;
    Queryname = "";
    status = "1";
    statesid = "";
    Queryid = [];
    seoUrl = "";
    statuspopup = false;
    addQueryname = "";
    imageurl = "";
    logoimage = "";
    Queryimage = "";
    Base64logoImage = "";
    Base64QueryImage = "";
    logofile = [];
    allQuery = [];
    alldeactivate = 'false';
    isQueryUpdated = "false";
    isLogoUpdated = "false"
    checkeddd = '';
    QueryFormDetails = {
        "title": "",
        "section_name": "",
        "url": "",
        "section_id": "",
        "image_name": "",
        "is_active": ""
    };
    saved = false;

    constructor(isloading = false) {
        makeAutoObservable(this, {
            addQueryname: observable,
            status: observable,
            errorMessages: observable,
            setaddQueryname: action,
            getstatus: action,
            resetErrors: action,
        });

        this.Token = localStorage.getItem("Admintoken");
        if (isloading.isloading) {
            this.getQueryList();
            //   this.getStateList();
            return
        }
        // if (isloading.addloading) {
        //     this.getQueryTypeList();
        // }
        // if (isloading.Queryeditloading) {
        //     this.getQueryform(isloading.id);
        //     this.getQueryTypeList();

        //     return
        // }
    }
    //All Clear 
    allclear = () => {
        this.filterSearch = ""
        this.getFilterQuery();
        //   this.status="";
        //   this.statesid="";
    }
    setimage = (text, type) => {
        this.imageurl = URL.createObjectURL(text[0]);
    }

    setalldeactivate = (text) => {
        console.log(text);
        this.alldeactivate = !this.alldeactivate;
    };

    getid = (text) => {
        this.Queryid.push(text);
    };



    // status popup
    setstatuspopup = () => {
        this.statuspopup = !this.statuspopup;
    };


    setallQuery = (text) => {
        this.allQuery = text;
    }

    // get status 
    getstatus = (text) => {
        this.status = text;
    };

    //get city name
    getQueryname = (text) => {
        this.Queryname = text;
    };

    setaddQueryname = (text) => {
        this.addQueryname = text;
    };
    setCrop = (text) => {
        this.crop = text;
    };

    setQueryDimiensions = (text) => {
        this.QueryDimiensions = text;
    };

    setlogofile = (e) => {
        this.logofile = e;
        console.log(this.logofile);
    };

    setQuerypopup = (e) => {
        this.Querypopup = e;
    };
    setdeletepopup = (e) => {
        this.deletepopup = e;
    };
    setdelateLoader = (e) => {
        this.delateLoader = e;
    }
    getToken = (e) => {
        this.Token = e;
    }
    gettype = (e) => {
        this.type = e;
    }
    getseourl = (text) => {
        // console.log(`https://demo.e-kart.com/${text}`);
        this.seoUrl = text;
    };
    getlogoimage = (text) => {
        console.log("checking in the Query", text);
        this.logoimage = text;
    };
    getQuery_image = (text) => {
        console.log(text);
        this.Queryimage = text;
    };
    SetfilterSearch = (text) => {
        this.filterSearch = text;
    };
    setPaginationPage = (text) => {
        this.PaginationPage = text;
    };
    SetTotalPages = (text) => {
        this.TotalPages = text;
    };
    setchecked = (text) => {
        this.checkeddd = text;
    };
    setisQueryUpdated = (text) => {
        this.isQueryUpdated = text;
    };
    setisLogoUpdated = (text) => {
        this.isLogoUpdated = text;
    };

    isBase64 = (str) => {
        try {
            return btoa(atob(str)) === str;
        } catch (err) {
            return false;
        }
    };

    setQueryFormDetails = (QueryDetail) => {
        this.QueryFormDetails = {
            ...this.QueryFormDetails,
            title: QueryDetail.title || "", // Use default value if name is undefined
            url: QueryDetail.url || "", // Use default value if seo_url is undefined
            // logo_image: this.isBase64( this.QueryFormDetails.logo_image) ? this.logofile.length == 0 ? QueryDetail.logo_image    : this.QueryFormDetails.logo_image  : this.logofile.length !== 0 ? this.QueryFormDetails.logo_image :  QueryDetail.logo_image   || "",
            // Query_image: this.isBase64(QueryDetail.Query_image) ? this.QueryFormDetails.Query_image : QueryDetail.Query_image || "",
            image_name: QueryDetail.image_name || "",
            section_id: QueryDetail.section_id || "",
            section_name: QueryDetail.section_name || "",

            is_active: QueryDetail.is_active
        };
    };
    // setQueryFormDetails = (text) => {
    //     this.QueryFormDetails = text;
    //     console.log("setQueryFormDetails", this.QueryFormDetails.Queryname);
    // };
    base64toFile(base64Data, fileName, mimeType) {
        if (base64Data) {
            const byteCharacters = atob(base64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters?.length; offset += 512) {
                const slice = byteCharacters?.slice(offset, offset + 512);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const file = new File(byteArrays, fileName, { type: mimeType });

            return file;
        }

    }

    // get Query list
    getQueryList = () => {
        runInAction(() => {
            this.QueryLoader = true;
            this.errLoadQuery = "";
            this.saved = false;
            this.nolist = false;
            this.Query = [];
        });
        getMethodData(`/api/v1/admin/feedback/get-list`, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.QueryLoader = false;
                        this.errLoadQuery = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.QueryLoader = false;
                        this.errLoadQuery = resp?.data?.message;
                        if (resp?.data?.data.length === 0) {
                            this.nolist = true;
                        } else {
                            this.nolist = false;
                        }
                        this.Query = resp?.data?.data;
                        // this.SetTotalPages(resp?.data?.totalPage)
                        this.saved = false;
                        // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.QueryLoader = false;
                    this.errLoadQuery = resp?.data?.message;
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.QueryLoader = false;
                    if (!error.response) {
                        this.errLoadQuery = error?.message;
                        toast.error(error?.message);
                    }
                    this.errLoadQuery = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
    };


    // filter League court

    getFilterQuery = () => {
        runInAction(() => {
            this.QueryLoader = true;
            this.errQueryLoader = "";
            this.saved = false;
            this.nolist = false;
            this.getQueryList = [];
        });
        postMethodData(`/api/v1/admin/Query/search?page=${this.PaginationPage}`, {
            keyword: this.filterSearch
        }, this.Token)
            .then((resp) => {

                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.loadleague = false;
                        this.QueryLoader = false;

                        this.errloadleague = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {

                    runInAction(() => {
                        this.loadcity = false;
                        this.QueryLoader = false;
                        this.errloadleague = resp?.data?.message;
                        if (resp?.data?.data.length === 0) {
                            this.nolist = true;
                        } else {
                            this.nolist = false;
                        }
                        this.Query = resp?.data?.data;
                        this.SetTotalPages(resp?.data?.totalPage)
                        this.saved = false;
                        // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.loadcity = false;
                    this.errloadcuty = resp?.data?.message;
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.loadleague = false;
                    this.QueryLoader = false;

                    if (!error.response) {
                        this.errloadleague = error?.message;
                        toast.error(error?.message);
                    }
                    this.errloadleague = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
    };



    //Active and inactive
    statusChange = () => {
        runInAction(() => {
            this.SectionLoader = true;
            this.Sectionpopup = true;

            this.errLoadSection = "";
        });
        postMethodData(`/api/v1/admin/Query/update-status`, {

            "record_id": this.Queryid,
            "status": JSON.stringify(this.status)

        }, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.Sectionid = [];
                        this.Queryid = [];

                        this.SectionLoader = false;
                        this.Querypopup = false;
                        this.errLoadSection = resp?.data?.message;
                        toast.error(resp?.data?.message);
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.SectionLoader = false;
                        this.Querypopup = false;
                        this.errLoadSection = resp?.data?.message;
                        this.getFilterQuery();
                        this.Sectionid = [];
                        this.Queryid = [];
                        toast.success(resp?.data?.message);
                    })
                    return;
                }
                runInAction(() => {
                    this.SectionLoader = false;
                    this.Querypopup = false;

                    this.errLoadSection = resp?.data?.message;
                })
            })
            .catch((error) => {
                this.Queryid = [];

                runInAction(() => {
                    if (!error.response) {
                        this.SectionLoader = false;
                        this.Querypopup = false;
                        this.Sectionid = [];
                        this.errLoadSection = error?.message;
                        toast.error(error?.message);
                    }
                    toast.error(error?.response?.data?.message);
                    this.SectionLoader = false;
                    this.Querypopup = false;
                    this.Sectionid = [];


                    this.errLoadSection = error?.response?.data?.message;
                })
                return;
            })
    };


    //Delete method
    deletefunction = () => {
        runInAction(() => {
            this.setdelateLoader(true);
            this.deletepopup = true;
            this.errLoadQuery = "";
        });
        postMethodData(`/api/v1/admin/Query/delete`, {

            "record_id": this.Queryid,

        }, this.Token).then((resp) => {
            if (resp?.data?.status === false) {
                runInAction(() => {
                    this.Queryid = [];

                    this.LoadQuery = false;
                    this.setdelateLoader(true);
                    this.deletepopup = true;
                    this.errLoadQuery = resp?.data?.message;
                    toast.error(resp.data.message);
                });
                return;
            }
            if (resp?.data?.status === true) {
                runInAction(() => {
                    this.LoadQuery = false;
                    this.Queryid = [];

                    this.setdelateLoader(false);
                    this.deletepopup = false;
                    this.errLoadQuery = resp?.data?.message;
                    this.getFilterQuery();
                    toast.success(resp.data.message);
                })
                return;
            }
            runInAction(() => {
                this.LoadQuery = false;
                this.errLoadQuery = resp?.data?.message;
            });

        })
            .catch((error) => {
                runInAction(() => {
                    this.addloadcity = false;
                    this.Queryid = [];

                    if (!error.response) {
                        this.LoadQuery = false;
                        this.setdelateLoader(false);
                        this.deletepopup = false;
                        this.errLoadQuery = error?.message;
                        toast.error(error?.message);
                    }
                    this.LoadQuery = false;
                    this.errLoadQuery = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            })
    }






}




export const QueryStoreContext = createContext(new QueryStore());
export const useQueryStore = () => useContext(QueryStoreContext);
